<script lang="ts">
import { defineComponent } from 'vue';
import { onLaunch } from '@dcloudio/uni-app';
import system from '@/store/system';

export default defineComponent({
  setup() {
    onLaunch(options => {
      console.error(options, 'app launch options');

      const { updateApp, updateAppConfig, updateThemeId } = system();

      updateApp();
      updateAppConfig();
      updateThemeId();

      // 支付宝使用
      if (options.query && options.query.qrCode) {
        const app = getApp();
        app.globalData.scanData = options.query.qrCode;
      }
    });
  },
});
</script>

<style lang="scss">
@import './uni.scss';

@import './tailwind.scss';

@import 'uview-plus/index.scss';
@import './style/uview-plus.scss';

@import './style/common.scss';

/* 响应式容器 - 在桌面端限制宽度为手机尺寸 */
@media screen and (min-width: 768px) {
  /* 为 body 添加居中背景 */
  body {
    background-color: #f0f0f0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: 100vh;
  }

  /* uni-app 根容器 */
  #app,
  uni-page-body,
  uni-page-wrapper {
    max-width: 414px !important;
    width: 100% !important;
    margin: 0 auto !important;
    background: #fff;
    position: relative;
  }
  .uni-page-head {
    max-width: 414px !important;
    width: 100% !important;
    margin: 0 auto !important;
  }

  /* 确保页面内容不超出容器 */
  uni-page-body {
    overflow-x: hidden;
  }

  /* 修复 fixed 定位元素在响应式容器中的位置 */
  .fixed {
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%);
    max-width: 414px;
    width: 100%;
  }
}
</style>
